/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsProductScopeListItem,
    MelcoModelsProductScopeListItemFromJSON,
    MelcoModelsProductScopeListItemFromJSONTyped,
    MelcoModelsProductScopeListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsProductScopeListItem
 */
export interface MelcoModelsGenericList1MelcoModelsProductScopeListItem {
    /**
     * 
     * @type {Array<MelcoModelsProductScopeListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsProductScopeListItem
     */
    list: Array<MelcoModelsProductScopeListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsProductScopeListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsProductScopeListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsProductScopeListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsProductScopeListItem {
    return MelcoModelsGenericList1MelcoModelsProductScopeListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsProductScopeListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsProductScopeListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsProductScopeListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsProductScopeListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsProductScopeListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsProductScopeListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


